/* XTRA Whey 2-bag deal, applied only when the shopper picks it
   (Theme settings > Offers > XTRA Whey 2-bag deal).
   The deal is a discount code (buy 1 get 1 £4.99 off). This script adds that code to the
   basket only when someone:
     - clicks Add 2 bags on the multibuy page (assets/xw-multibuy.js calls xwMb.claim), or
     - uses the basket prompt under the XTRA Whey line (snippets/xw-mb-prompt.liquid):
       "Add a second bag" (odd number of bags) or "Claim the deal" (even number, no code).
   Adding two bags without either gets no discount. The code is removed again when the last
   bag leaves the basket. Codes the shopper already has (e.g. SEPTEMBER) are kept: the
   discount parameter replaces the whole list, so it is always sent in full.
   The × records _xwmb_dismissed on the basket: the offer stays hidden for that basket and
   the drawer's upsell sheet comes back.
   Cart attributes for tracking: _xwmb_shown, _xwmb_claimed, _xwmb_source, _xwmb_dismissed.

   Offers source = DS Offers app (snippets/xw-mb-assets.liquid sets cfg.source to "app"): the deal is
   the multibuy offer in the manifest, with UTC ISO dates (cfg.startIso, cfg.endIso). An automatic
   offer (cfg.auto, no code) applies by itself, so there is nothing to claim and no code to tidy up:
   claim() only records where the second bag came from (_xwmb_source) and the tidy-up below does not run.

   App path, the prompt opens and closes with the offer's dates while the page stays open (6 Oct): a timer wakes this
   script at the next start or end that is under 24 hours away (a day later otherwise) and puts the xwmb-on class on
   or takes it off.

   App path, currency (6 Oct): in a basket that is not in the shop's currency (Ireland, euros) snippets/xw-mb-prompt.liquid
   cannot print the deal's figures (the offer's price is pence of the shop's currency; checkout charges it converted with
   the presentment rate and rounded, Math.round(pence x rate)), so it draws empty slots (data-xwmb-fx) on each card with
   the numbers they need. They are filled here from Shopify.currency.rate in the theme's money format, now and after every
   redraw of the drawer. With no usable rate the card shows the deal without a price.
   Plain ES5-style script: the CDN compiles theme JS (L-055). */
(function () {
  'use strict';
  if (window.xwMb) return;
  var cfgEl = document.querySelector('[data-xwmb-json]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var CODE = String(cfg.code || '').trim().toUpperCase();
  var AUTO = cfg.auto === true;
  if (!cfg.productId || (!CODE && !AUTO)) return;

  /* ---- offer window, UK time ---- */
  function londonOffset(date) {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
      .formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second) - Math.floor(date.getTime() / 1000) * 1000;
  }
  function parseUk(str) {
    var m = String(str || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return null;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    return guess - londonOffset(new Date(guess));
  }
  /* DS Offers dates are UTC ISO strings. Open means start <= now < end, like assets/offers.js: a blank
     start has no lower limit, a blank or unreadable end counts as closed. Preview scheduled offers
     (dev theme only) ignores the start. */
  function openIso(startIso, endIso, ignoreStart) {
    var s = (ignoreStart || !startIso) ? -Infinity : Date.parse(startIso);
    var e = Date.parse(endIso);
    var t = Date.now();
    return t >= s && t < e;
  }
  function computeLive() {
    if (cfg.source === 'app') return openIso(cfg.startIso, cfg.endIso, cfg.previewScheduled === true);
    var start = parseUk(cfg.start), end = parseUk(cfg.end), now = Date.now();
    return !(start && now < start) && !(end && now >= end);
  }
  var live = computeLive();
  // The prompt is rendered hidden; this class shows it, including after the drawer re-renders.
  if (live) document.documentElement.classList.add('xwmb-on');

  /* App path: wake at the next start or end under 24 hours away (a day later otherwise) and open or close the prompt.
     The settings path is opened once on load, as before. A timer that fires a moment early finds the edge not yet
     passed and sets itself again for it. */
  var DAY = 24 * 60 * 60 * 1000;
  var liveTimer = null;
  function armLive() {
    clearTimeout(liveTimer);
    var now = Date.now();
    var next = null;
    [cfg.previewScheduled === true ? '' : cfg.startIso, cfg.endIso].forEach(function (iso) {
      var t = Date.parse(iso);
      if (!isNaN(t) && t > now && (next === null || t < next)) next = t;
    });
    var wait = next !== null && next - now < DAY ? next - now + 50 : DAY;
    liveTimer = setTimeout(function () {
      var l = computeLive();
      if (l !== live) {
        live = l;
        document.documentElement.classList.toggle('xwmb-on', live);
        watchImpression();
      }
      armLive();
    }, wait);
  }
  if (cfg.source === 'app') armLive();

  function json(url, body) {
    return fetch(url, body ? {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    } : { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Something went wrong');
        return j;
      });
    });
  }
  function codesOf(cart) {
    return (cart.discount_codes || []).map(function (d) { return String(d.code || '').toUpperCase(); }).filter(Boolean);
  }
  /* One-time bags only, as in snippets/xw-mb-prompt.liquid: the deal does not apply to subscription lines. */
  function bagsIn(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (+it.product_id === +cfg.productId && !it.selling_plan_allocation) n += it.quantity; });
    return n;
  }
  function refresh() {
    var el = document.documentElement;
    el.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* Add the deal code to whatever codes the basket already has. An automatic offer has no code to
     add: it applies by itself, so only record where the second bag came from. */
  function claim(source) {
    if (!live) return Promise.resolve();
    if (AUTO) return json('/cart/update.js', { attributes: { _xwmb_source: source || 'unknown' } });
    return json('/cart.js').then(function (cart) {
      var codes = codesOf(cart);
      var body = { attributes: { _xwmb_claimed: '1', _xwmb_source: source || 'unknown' } };
      if (codes.indexOf(CODE) === -1) body.discount = codes.concat(CODE).join(',');
      return json('/cart/update.js', body);
    });
  }
  window.xwMb = { claim: claim, code: CODE, auto: AUTO };

  /* ---- basket prompt buttons (the drawer re-renders, so listen on the document) ---- */
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-xwmb-close]');
    if (x) {
      e.preventDefault();
      var card = x.closest('[data-xwmb]');
      if (card) card.hidden = true;
      json('/cart/update.js', { attributes: { _xwmb_dismissed: '1' } }).then(refresh).catch(function () {});
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-xwmb-act]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var box = btn.closest('[data-xwmb]');
    var act = btn.getAttribute('data-xwmb-act');
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = act === 'add' ? 'Adding…' : 'Applying…';
    var step;
    if (act === 'add') {
      var sel = box && box.querySelector('[data-xwmb-variant]');
      var id = +(sel ? sel.value : btn.getAttribute('data-variant'));
      step = json('/cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(function () { return claim('basket_add'); });
    } else {
      step = claim('basket_claim');
    }
    step.then(function () {
      refresh();
    }).catch(function (err) {
      btn.removeAttribute('aria-busy');
      btn.textContent = label;
      var msg = box && box.querySelector('[data-xwmb-msg]');
      if (msg) { msg.textContent = err.message; msg.hidden = false; }
    });
  });

  /* ---- tidy up: take the code off when the last bag leaves the basket ---- */
  if (!window.__xwCartWatch && window.fetch) {
    window.__xwCartWatch = true;
    var orig = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var res = orig.apply(window, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        res.then(function () { document.dispatchEvent(new CustomEvent('xw:cart-write')); }, function () {});
      }
      return res;
    };
  }
  var tidyTimer = null;
  /* Automatic offers have no code on the basket, so there is nothing to take off. */
  if (!AUTO) document.addEventListener('xw:cart-write', function () {
    clearTimeout(tidyTimer);
    tidyTimer = setTimeout(function () {
      json('/cart.js').then(function (cart) {
        var codes = codesOf(cart);
        if (bagsIn(cart) > 0 || codes.indexOf(CODE) === -1) return;
        return json('/cart/update.js', { discount: codes.filter(function (c) { return c !== CODE; }).join(',') }).then(refresh);
      }).catch(function () {});
    }, 400);
  });

  /* ---- impression: first time the prompt is on screen this session ---- */
  var shownKey = 'xwmb-shown';
  function stampShown() {
    try { if (sessionStorage.getItem(shownKey) === '1') return; sessionStorage.setItem(shownKey, '1'); } catch (e) {}
    json('/cart/update.js', { attributes: { _xwmb_shown: '1' } }).catch(function () {});
  }
  var watching = false;
  function watchImpression() {
    if (watching || !live || !('MutationObserver' in window)) return;
    watching = true;
    var seen = false;
    new MutationObserver(function () {
      if (seen) return;
      var box = document.querySelector('[data-xwmb-offer]');
      if (box && box.offsetParent !== null) { seen = true; stampShown(); }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
  }
  watchImpression();

  /* ---- currency: fill the deal's figures in a basket that is not in the shop's currency (App path) ---- */
  function dealMinor(pence) {
    var p = +pence;
    if (!(p > 0) || Math.floor(p) !== p) return null;
    var cur = window.Shopify && Shopify.currency;
    // The card was drawn for a basket in another currency than the shop's; if the page does not agree, no price.
    if (!cur || !cur.active || String(cur.active) === String(cfg.shopCurrency || 'GBP')) return null;
    var rate = Number(cur.rate);
    if (!isFinite(rate) || !(rate > 0)) return null;
    var out = Math.round(p * rate);
    return out > 0 ? out : null;
  }
  function fxMoney(minor) {
    try {
      var f = window.theme && window.theme.moneyFormat;
      if (f && window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(Math.round(minor), f);
    } catch (e) {}
    return null;
  }
  function fillCard(box) {
    box.setAttribute('data-xwmb-filled', '1');
    var q = +box.getAttribute('data-xwmb-q');
    var unit = +box.getAttribute('data-xwmb-unit');
    var deal = dealMinor(box.getAttribute('data-xwmb-pence'));
    var priced = deal !== null && q >= 2 && unit > 0 && fxMoney(deal) !== null;
    var save = priced ? unit * q - deal : 0;
    var second = priced ? deal - unit * (q - 1) : 0;
    var texts = {
      deal: priced ? fxMoney(deal) : '',
      save: save > 0 ? fxMoney(save) : '',
      second: second > 0 ? fxMoney(second) : ''
    };
    Array.prototype.forEach.call(box.querySelectorAll('[data-xwmb-fx]'), function (el) { el.textContent = texts[el.getAttribute('data-xwmb-fx')] || ''; });
    Array.prototype.forEach.call(box.querySelectorAll('[data-xwmb-need]'), function (el) {
      var need = el.getAttribute('data-xwmb-need');
      el.hidden = !(need === 'deal' ? priced : need === 'save' ? save > 0 : need === 'second' ? second > 0 : need === 'nodeal' ? !priced : true);
    });
  }
  function fillCards() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-xwmb-pence]:not([data-xwmb-filled])'), fillCard);
  }
  if (cfg.source === 'app') {
    fillCards();
    // The drawer is drawn again after every basket change; a card that has just arrived is filled before it is painted.
    if ('MutationObserver' in window) new MutationObserver(fillCards).observe(document.body, { childList: true, subtree: true });
  }
})();
